import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/api/core";
import { useAuth } from "@/contexts/auth/useAuth";
import { useStatContext } from "@/contexts/stat-context";
import { useApi } from "@/hooks";

function useAlertCount() {
  const api = useApi();
  const { isLoggedIn } = useAuth();
  const { setUnreadAlertsCount } = useStatContext();

  const getCount = async () => {
    const { data } = await api.get<{ count: number }>("/api/v1/alerts/count");
    setUnreadAlertsCount(data.count);
    return data;
  };

  const { data, ...rest } = useQuery({
    queryKey: QueryKeys.alerts.count(),
    queryFn: getCount,
    enabled: isLoggedIn,
  });

  return {
    data,
    ...rest,
    count: data?.count,
  };
}

export { useAlertCount };
